import React from "react"
import Footer from "../components/footer"
import Navbar from "../components/nav"
function KYTPolicy() {
  return (
    <>
      <div>
        <header className="header-area">
          <div className="navbar-area">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <Navbar />
                </div>
              </div>
            </div>
          </div>
        </header>

        <div id="home">
          <div className="container mt-125 mb-50">
            <div className="">
              <div className="card-body shadow">
                <h4>Privacy Policy for Kolay Yemek Tarifleri Android App</h4>
                <br />
                <ul>
                  <li>THE DEVELOPER = MWX Apps</li>
                  <li>THE APP = Kolay Yemek Tarifleri</li>
                  <br />
                </ul>
                <p>
                  THE DEVELOPER built THE APP as an ad supported app. This service is
                  provided by THE DEVELOPER at no cost and is intended for use as is.
                </p>
                <p>
                  This page is used to inform visitors regarding our policies with
                  the collection, use, and disclosure of personal information if
                  anyone decided to use THE APP.
                </p>
                <p>
                  If you choose to use THE APP, then you agree to the collection and
                  use of information in relation to this policy. The personal
                  information that we collect is used for providing and improving the
                  service. We will not use or share your information with anyone
                  except as described in this Privacy Policy.
                </p>
                <p>
                  The terms used in this Privacy Policy have the same meanings as in
                  our Terms and Conditions, which is accessible at THE APP unless
                  otherwise defined in this Privacy Policy.
                </p>
                <br />
                <strong>
                  <a
                    href="#information-collection-and-use"
                    aria-hidden="true"
                    tabindex="-1"
                  >
                    <span class="icon icon-link"></span>
                  </a>
                  Information Collection and Use
                </strong>
                <p>
                  For a better experience, while using our service, we may require
                  you to provide us with certain personally identifiable information.
                  The information that we request will be retained on your device and
                  is not collected by us in any way.
                </p>
                <p>
                  THE APP does use third party services that may collect information
                  used to identify you.
                </p>
                <p>
                  Links to privacy policy of third party service providers used by
                  THE APP
                </p>
                <br />
                <ul>
                  <li>
                    <a
                      href="https://policies.google.com/privacy"
                      rel="nofollow noopener noreferrer"
                      target="_blank"
                    >
                      Google Play Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://firebase.google.com/policies/analytics"
                      rel="nofollow noopener noreferrer"
                      target="_blank"
                    >
                      Firebase
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://support.google.com/admob/answer/6128543?hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      AdMob
                    </a>
                  </li>
                </ul>
                <br />
                <strong id="log-data">
                  <a href="#log-data" aria-hidden="true" tabindex="-1">
                    <span class="icon icon-link"></span>
                  </a>
                  Log Data
                </strong>
                <p>
                  We want to inform you that whenever you use THE APP, in a case of
                  an error in THE APP we collect data and information (through third
                  party products) on your phone called log data. This log data may
                  include information such as your device Internet Protocol (IP)
                  address, device name, operating system version, the time and date
                  of your use of the service, and other statistics.
                </p>
                <br />
                <strong>Cookies</strong>
                <p>
                  Cookies are files with a small amount of data that are commonly
                  used as anonymous unique identifiers. These are sent to your
                  browser from the websites that you visit and are stored on your
                  device's internal memory.
                </p>
                <p>
                  This service does not use these "cookies" explicitly. However, THE
                  APP may use third party code and libraries that use "cookies" to
                  collect information and improve their services. You have the option
                  to either accept or refuse these cookies and know when a cookie is
                  being sent to your device. If you choose to refuse our cookies, you
                  may not be able to use some portions of this service.
                </p>
                <br />
                <strong id="service-providers">
                  <a href="#service-providers" aria-hidden="true" tabindex="-1">
                    <span class="icon icon-link"></span>
                  </a>
                  Service Providers
                </strong>
                <p>
                  We may employ third-party companies and individuals due to the
                  following reasons:
                </p>
                <ul>
                  <li>To facilitate our service;</li>
                  <li>To provide the service on our behalf;</li>
                  <li>To perform service-related services; or</li>
                  <li>To assist us in analyzing how our service is used.</li>
                </ul>
                <p>
                  We want to inform users of this service these third parties have
                  access to your personal information. The reason is to perform the
                  tasks assigned to them on our behalf. However, they are obligated
                  not to disclose or use the information for any other purpose.
                </p>
                <br />
                <strong id="security">
                  <a href="#security" aria-hidden="true" tabindex="-1">
                    <span class="icon icon-link"></span>
                  </a>
                  Security
                </strong>
                <p>
                  We value your trust in providing us your personal information, thus
                  we are striving to use the commercially acceptable means of
                  protecting it but remember that no method of transmission over the
                  internet, or method of electronic storage is 100% secure and
                  reliable, and we cannot guarantee its absolute security.
                </p>
                <br />
                <strong id="links-to-other-sites">
                  <a href="#links-to-other-sites" aria-hidden="true" tabindex="-1">
                    <span class="icon icon-link"></span>
                  </a>
                  Links to Other Sites
                </strong>
                <p>
                  This service may contain links to other sites. If you click on a
                  third-party link, you will be directed to that site. Note that
                  these external sites are not operated by us. Therefore, we strongly
                  advise you to review the Privacy Policy of these websites. We have
                  no control over and assume no responsibility for the content,
                  privacy policies, or practices of any third-party sites or
                  services.
                </p>
                <strong id="childrens-privacy">
                  <a href="#childrens-privacy" aria-hidden="true" tabindex="-1">
                    <span class="icon icon-link"></span>
                  </a>
                  Children's Privacy
                </strong>
                <p>
                  These services do not address anyone under the age of 13. We do not
                  knowingly collect personally identifiable information from children
                  under 13. In the case we discover that a child under 13 age
                  provided us with personal information, we immediately delete this
                  from our servers. If you are a parent or guardian and you are aware
                  your child has provided us with personal information, please
                  contact us so that we will be able to do necessary actions.
                </p>
                <br />
                <strong id="changes-to-this-privacy-policy">
                  <a
                    href="#changes-to-this-privacy-policy"
                    aria-hidden="true"
                    tabindex="-1"
                  >
                    <span class="icon icon-link"></span>
                  </a>
                  Changes to This Privacy Policy
                </strong>
                <p>
                  We may update our Privacy Policy from time to time. Thus, you are
                  advised to review this page periodically for any changes. These
                  changes are effective immediately after they are posted on this
                  page.
                </p>
                <br />
                <strong id="contact-us">
                  <a href="#contact-us" aria-hidden="true" tabindex="-1">
                    <span class="icon icon-link"></span>
                  </a>
                  Contact Us
                </strong>
                <p>
                  If you have any questions or suggestions about this Privacy Policy,
                  do not hesitate to contact us. E-mail: web-developer [at]
                  outlook.com
                </p>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default KYTPolicy
